export function objectToQueryString(
  obj: Record<string, any>,
  parentKey: string = "",
): string {
  const keyValuePairs = [];

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      const newKey = parentKey ? `${parentKey}.${key}` : key;

      if (typeof value === "object" && value !== null) {
        // Recursively convert nested objects
        keyValuePairs.push(objectToQueryString(value, newKey));
      } else if (!!value) {
        // Convert key-value pair to a string
        keyValuePairs.push(`${newKey}=${encodeURIComponent(value)}`);
      } else {
        // Convert to key string
        keyValuePairs.push(newKey);
      }
    }
  }

  return keyValuePairs.join("&");
}

export function queryStringToObject(queryString: string): Record<string, any> {
  const object = {};

  if (!queryString) {
    return object;
  }

  const pairs = queryString.split("&");
  pairs.forEach((pair) => {
    const [key, value] = pair.split("=");
    const keys = key.split(".");
    let currentObject: Record<string, any> = object;

    for (let i = 0; i < keys.length; i++) {
      const currentKey = keys[i];
      const nextKey = keys[i + 1];

      if (nextKey) {
        // Create an empty object for the next key if it doesn't exist
        if (!currentObject[currentKey]) {
          currentObject[currentKey] = isNaN(nextKey as unknown as number)
            ? {}
            : [];
        }

        // Move to the next level
        currentObject = currentObject[currentKey];
      } else {
        const parsedValue =
          typeof value === "undefined" ? undefined : decodeURIComponent(value);
        if (Array.isArray(currentObject)) {
          const arrayIndex = parseInt(currentKey, 10);
          currentObject[arrayIndex] = parsedValue;
        } else {
          // If it's the last key, assign the value
          currentObject[currentKey] = parsedValue;
        }
      }
    }
  });

  return object;
}
